import * as Actions from './actions';

export const mapDispatchToProps = (dispatch, ownProps) => ({
    clickPrev: (...args) => {
        dispatch(Actions.clickPrev(ownProps.section)(...args));
    },
    clickPrevAnimationStart: (...args) => {
        dispatch(Actions.clickPrevAnimationStart(...args));
    },
    clickNext: (...args) => {
        dispatch(Actions.clickNext(ownProps.section)(...args));
    },
    clickNextAnimationStart: (...args) => {
        dispatch(Actions.clickNextAnimationStart(...args));
    },
    onClickExpandMap: () => {
        ownProps.onClickExpandMap ? ownProps.onClickExpandMap() : {};
        dispatch(Actions.trackClickExpandMap(ownProps.section)());
    },
    trackInsuranceStatusUpdate: (...args) => {
        dispatch(Actions.trackInsuranceStatusUpdate(ownProps.section)(...args));
    },
});

export default mapDispatchToProps;
